import React from "react";
import "./SuccessPage.css"; // We'll define our animation CSS here

function SuccessPage() {
  return (
    <div className="d-flex align-items-center justify-content-center vh-100 success-background">
      <div className="success-card text-center p-5">
        {/* Animated Checkmark SVG */}
        <div className="check-container mb-4">
          <svg className="checkmark" viewBox="0 0 52 52">
            <circle
              className="checkmark-circle"
              cx="26"
              cy="26"
              r="25"
              fill="none"
            />
            <path
              className="checkmark-check"
              fill="none"
              d="M14.1 27.2l7.1 7.2 16.7-16.8"
            />
          </svg>
        </div>

        <h1 className="mb-3" style={{ color: "#333" }}>
          Success!
        </h1>
        <p>Your message has been successfully sent!</p>

        {/* “Go Back” button – Adjust href to your desired route */}
        <a href="/" className="btn btn-primary mt-3">
          Go Back
        </a>
      </div>
    </div>
  );
}

export default SuccessPage;
